const exampleResponse = {
  // Use test data from courseTestData
  schedules: [
    {
      courseId: "FGAZD3",
      scheduleId: 111111,
      locationId: 111111,
      startTime: "2025-06-04T09:00:00Z",
      endTime: "2025-06-06T16:30:00Z",
      availablePlaces: 50,
      totalPlaces: 200,
      unitPrice: "999.80",
    },
    {
      courseId: "FGAZD3",
      scheduleId: 111111,
      locationId: 111111,
      startTime: "2025-06-04T09:00:00Z",
      endTime: "2025-06-06T16:30:00Z",
      availablePlaces: 50,
      totalPlaces: 200,
      unitPrice: "999.80",
    },
    {
      courseId: "DTB004",
      scheduleId: 111111,
      locationId: 12345,
      startTime: "2025-06-04T09:00:00Z",
      endTime: "2025-06-06T16:30:00Z",
      availablePlaces: 50,
      totalPlaces: 200,
      unitPrice: "999.80",
    },
  ],
  locations: [
    {
      locationId: 111111,
      name: "Test Course ( Working VID - Mixed )",
      address: "Faulkner Street, Manchester, Greater Manchester, M1 4DY",
      latitude: 53.47842053494967,
      longitude: -2.239900894612969,
      distance: 0.19,
    },
    {
      locationId: 12345,
      name: "Manchester City Centre",
      address: "Faulkner Street, Manchester, Greater Manchester, M1 4DY",
      latitude: 53.47842053494967,
      longitude: -2.239900894612969,
      distance: 0.19,
    },
  ],
  meta: {},
};

export default exampleResponse;
export { exampleResponse };
